import React from "react";
import { Skeleton } from "@material-ui/lab";
import PropTypes from "prop-types";

// import useStyles from "./useStyles";

const Placeholder = ({ variant, children, ratio, classes: originalClases, animation, className, width, height }) => {
  const getStyle = () => {
    if (!ratio) return {};
    const [w, h] = ratio.split("x");
    const paddingTop = `${(h * 100.0) / w}%`;
    return { height: 0, paddingTop };
  };

  return (
    <Skeleton
      classes={originalClases}
      className={className}
      style={getStyle()}
      variant={variant}
      width={width}
      height={height}
      animation={animation}
    >
      {children}
    </Skeleton>
  );
};

Placeholder.propTypes = {
  variant: PropTypes.string,
  ratio: PropTypes.string,
  animation: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Placeholder;
